import { object, string, number } from 'yup';
import addUrlHasProtocolValidation from '@afosto/utils-react/validators/urlHasProtocol';

addUrlHasProtocolValidation();

export default object().shape({
  trackingCode: string(),
  trackingUrl: string().urlHasProtocol(),
  height: number(),
  width: number(),
  length: number(),
  weight: number(),
});
